export const setTargetImageEl = (self, target_image_el) => {
  self._checkNoProcessingTask();
  const target_image_inner_wrapper_g_el =
    self._getTargetImageInnerWrapperGElThrowable();
  const target_image_dummy_g_el = self._getTargetImageDummyGElThrowable();
  const stroke_sync = self._getStrokeSyncThrowable();
  if (self._target_image_el != null) {
    const target_image_el = self._target_image_el;
    if (target_image_el.contains(target_image_dummy_g_el)) {
      target_image_el.removeChild(target_image_dummy_g_el);
    }
    if (target_image_inner_wrapper_g_el.contains(target_image_el)) {
      target_image_inner_wrapper_g_el.removeChild(target_image_el);
    }
  }
  target_image_el.appendChild(target_image_dummy_g_el);
  target_image_inner_wrapper_g_el.appendChild(target_image_el);
  self._target_image_el = target_image_el;
  stroke_sync.sync();
};
